<div class="type{{data?.type}}" mat-dialog-title>{{ data.title }}</div>
<div mat-dialog-content>
  @for (text of data.display; track $index) {
    <div>{{ text }}</div>
  }
  @for (ctrl of data.controlList; track $index; let idx = $index) {
    @if (ctrl.type === 'selectgroup') {
      <app-select-group
        [formGroup]="form"
        [formName]="ctrl.key"
        [innerWidth]="2"
        [outerWidth]="2"></app-select-group>
    }
    @if (ctrl.type === 'radiogroup') {
      <app-radio-group
        [formGroup]="form"
        [formName]="ctrl.key"
        [innerWidth]="2"
        [outerWidth]="2"></app-radio-group>
    }
  }
</div>
<div class="type{{data?.type}}" mat-dialog-actions>
  @for (btn of data.buttons; track $index; let idx = $index) {
    @if (btn.focus) {
      <button (click)="closeDialog(btn)" cdkFocusInitial mat-button>
        {{ btn.title }}
      </button>
    }
    @if (!btn.focus) {
      <button (click)="closeDialog(btn)" mat-button>
        {{ btn.title }}
      </button>
    }
  }
</div>

